export default __webpack_public_path__ + "static/media/MW-Resume.ae6f8c69.pdf";